/**
 * Customer Data cloud - custom implementation
 */

import gigyaRegisterLogin from './rbata.registration-login';
import gigyaProfileUpdate from './rbata.profile-update';
import gigyaLiteRegistration from './rbata.lite-registration';
import loginPage from './rbata.login-page';
import personalizeService from '../services/rbata.personalizeService';
import tooltip from '../utils/rbata.tooltip';
import gigyaOrderConfirmation from './rbata.gigya-order-confirmation';
import navigationState from '../checkout/rbata.navigationState';
import newsletterModal from '../checkout/rbata.newsletter'

const gigya = {
    boostrapCDC: () => {
        gigya.bindHandler();
        gigya.isGigyaUserAuthenticated();
        loginPage.init();
        gigyaRegisterLogin.bindHandler();
        gigyaProfileUpdate.bindHandler();
        gigyaLiteRegistration.bindHandler();
        gigyaOrderConfirmation.load();
        // Critical function calls
        if (window.__gigyaConf) {
            gigya.gigyaCriticalFunctionCalls();
        } else {
            document.addEventListener('gigyaFunctions-ready', () => {
                gigya.gigyaCriticalFunctionCalls();
            });
        }
    },

    gigyaCriticalFunctionCalls: () => {
        window.gigyaHybris.gigyaFunctions.raasClick();
        window.gigyaHybris.gigyaFunctions.raasEmbed();
        gigya.gigyaRegister();
    },

    renderGlobalMessages: (msg) => {
        tooltip.showFormError(msg);
    },

    readCookie: (name) => {
        var cname         = name + '=';
        var decodedCookie = decodeURIComponent(gigya.deleteGigLLUPart(document.cookie));
        var ca            = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cname) == 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return null;
    },

    //Gig-llu cookie has a super weird encoding which breaks for non ascii characters if they are transmitted from CDC
    //so just remove this part from the cookie collection we have... they are not used here anyway
    deleteGigLLUPart: (cookies) => {
        var llu = '_gig_llu=';
        if(cookies.includes(llu)) {
            var startPos = cookies.indexOf(llu);
            var endPos = cookies.indexOf(';', startPos+1);
            var firstpart = cookies.substring(0,startPos);
            var secondpart = cookies.substring(endPos+1, cookies.length);
            return firstpart.concat(secondpart);
        }
        return cookies
    },

    removeGlobalMessages: () => {
        var $target = $('#globalMessages');

        $target.empty();
    },

    showPasswordCheckbox: () => {
        $(document.body).on('change', '.gigya-show-password input', function () {
            var pwdInput = $('input[name="newPassword"]'), pwdInputRetype = $('input[name="passwordRetype"]'),
                oldPwdInput                                               = $('input[name="password"]');

            if ($(this).prop('checked')) {
                pwdInput.prop('type', 'text');
                pwdInputRetype.prop('type', 'text');
                oldPwdInput.prop('type', 'text');
            } else {
                pwdInput.prop('type', 'password');
                pwdInputRetype.prop('type', 'password');
                oldPwdInput.prop('type', 'password');
            }
        });
    },

    clearUncheckedSubscriptions: (event) => {
        // Prevents implicit optOuts and unconsents on anonymous forms
        var formData      = event.detail.formModel;
        var subscriptions = formData.subscriptions;

        for (var key in subscriptions) {
            var subscription = subscriptions[key];
            if (subscription.email.isSubscribed === 'false' || subscription.email.isSubscribed === false) {
                delete subscriptions[key];
            }
        }
        return formData;
    },

    setAdditionalGeoDetails: (event) => {
        var profileData = event.detail.formModel.profile;
        if (profileData) {
            personalizeService.getPersonalizedData().then((data) => {
                profileData.country = data.countryFromCookie;
                profileData.city    = data.cityFromCookie;
            });
        }
    },

    setSpecialNlTag(event) {
        const formData = event.detail.formModel;
        const subscriptions = formData.subscriptions;
        const path = window.location.pathname;
        // Extract ID from URL if it matches
        const subscriptionSourceTag = path.includes('newsletter/register') ? path.split('newsletter/register').pop()?.replaceAll('/', '')
                : '';

        if (!!subscriptionSourceTag) {
            for (const key in subscriptions) {
                const subscription = subscriptions[key];
                if (subscription.email.isSubscribed && key.includes('newsletter')) {
                    subscriptions[key].email.tags = new Array(subscriptionSourceTag);
                }
            }
        }
        return formData;
    },

    clearEmailForLoggedIn: (evt) => {
        if ('detail' in evt) {
            var data     = evt.detail;
            var formData = data.formModel;

            /**
             * Remove email from event object if user is logged in.
             * This will prevent creating multiple email addresses on CDC account.
             */
            if (window.isGigyaUserAuthenticated) {
                delete formData.profile['email'];
            }
            return formData;
        }
    },

    isGigyaUserAuthenticated: () => {
        window.gigya.accounts.getAccountInfo({
            callback: function (response) {
                window.isGigyaUserAuthenticated = (response.errorCode === 0);
                gigya.handleNewsletterAvailiablityPerUser();
                newsletterModal.newsletterPopupInit();
                navigationState.init();
            }
        });
    },

    isUserSubscribedToNewsletter: () => {
        return new Promise((resolve, reject) => {
            window.gigya.accounts.getAccountInfo({
                include: 'subscriptions', callback: function (response) {
                    if (response['subscriptions']) {
                        if (response.subscriptions.hasOwnProperty('newsletter')) {
                            resolve(response.subscriptions.newsletter.email.isSubscribed);
                        } else {
                            resolve(false);
                        }
                    } else {
                        resolve(false);
                    }
                }
            })
        });
    },

    handleNewsletterAvailiablityPerUser() {
        let cookieValue = gigya.readCookie(gigyaLiteRegistration.newsletterCookieName);

        $('body').on('click', 'a', function (e) {
            const $thisLink = $(e.target).attr('href');

            if ($thisLink && !!$thisLink.match('/logout')) {
                document.cookie = `${gigyaLiteRegistration.newsletterCookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
                navigationState.resetStepState();
            }
        });

        const $cartNewsletter         = $('.cart__newsletter, .confirmation__newsletter');
        const $footerNewsletterColumn = $('.page-footer__newsletter-col');
        const $newsletterFooterForm   = $('.page-footer__newsletter');
        const $newsletterFooterTitle  = $('.page-footer__newsletter-col .page-footer__title');

        const applyChange = (flag) => {
            if (flag) {
                $cartNewsletter.addClass('d-none');
                $newsletterFooterForm.hide();
                $footerNewsletterColumn.addClass('page-footer__newsletter-col--reverse');
                $newsletterFooterTitle.hide();
            } else {
                $footerNewsletterColumn.removeClass('page-footer__newsletter-col--reverse');
                $newsletterFooterForm.show();
                $newsletterFooterTitle.show();
                $cartNewsletter.removeClass('d-none');
            }
        }

        if (!window.isGigyaUserAuthenticated) {
            applyChange(cookieValue);
        } else {
            gigya.isUserSubscribedToNewsletter().then((response) => {
                applyChange(response);
            });
        }
    },

    bindHandler: () => {
        var $body = $(document.body);
        $body.on('focusin', '.gigya-input-text, .gigya-input-password, .rbata-select select', function (evt) {
            var currentTarget = $(evt.currentTarget);
            currentTarget.closest('.gigya-composite-control').addClass('gigya-composite-control--focus');
            currentTarget.closest('.gigya-control--date-wrapper').addClass('gigya-composite-control--focus');
        });
        $body.on('focusout', '.gigya-input-text, .gigya-input-password, .rbata-select select', function (evt) {
            var currentTarget = $(evt.currentTarget);
            currentTarget.closest('.gigya-composite-control').removeClass('gigya-composite-control--focus');
            currentTarget.closest('.gigya-control--date-wrapper').removeClass('gigya-composite-control--focus');
        });
    },
    /*
     * Register login events
     */
    gigyaRegister: () => {
        if (ACC.gigyaUserMode === "raas") {
            window.gigya.accounts.addEventHandlers({
                onLogin: gigyaHybris.gigyaFunctions.raasLogin
            });
        }
    }
}

$(() => {
    window.gigyaCustom = {
        gigyaInit: gigya.boostrapCDC
    }
    let event          = new Event('gigyaCustom-ready', {bubbles: true});
    document.dispatchEvent(event);
});

export default gigya;
